import VM from "../main";
import { setEncryption, addUserTask, setMockEncryption,getPageVersion } from "@/api/common";
import { Message } from 'element-ui';
import $store from "@/store";
export const getRandom = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
//日期转换格式  "yyyy-MM-dd hh:mm:ss"
export const myFormater = (timeStr, fmt) => {
  let o = {
    "M+": new Date(timeStr).getMonth() + 1, //月份
    "d+": new Date(timeStr).getDate(), //日
    "h+": new Date(timeStr).getHours(), //小时
    "m+": new Date(timeStr).getMinutes(), //分
    "s+": new Date(timeStr).getSeconds(), //秒
    "q+": Math.floor((new Date(timeStr).getMonth() + 3) / 3), //季度
    S: new Date(timeStr).getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (new Date(timeStr).getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
export const getEnvironment = () => {
  if (
    window.location.origin == "https://online.eickaopei.com" ||
    window.location.origin == "https://m.eicsuyang.com" ||
    window.location.origin == "https://www.eicsuyang.com"
  ) {
    //正式站
    return "_build";
  } else {
    //测试站
    return "_test";
  }
};
const getWindowNavUrl = type => {
  // type:1-托福  2-雅思  3-gre  4-sat 5-20分钟自适应
  let url = "";
  switch (type - 0) {
    case 1:
      if (getEnvironment() == "_test") {
        url = "https://online-toefl-test.eiceducation.com.cn";
      } else {
        url = "https://online-toefl.eiceducation.com.cn";
      }
      break;
    case 2:
      if (getEnvironment() == "_test") {
        url = "https://online-ielts-test.eiceducation.com.cn";
      } else {
        url = "https://online-ielts.eiceducation.com.cn";
      }
      break;
    case 3:
      if (getEnvironment() == "_test") {
        url = "https://online-gre-test.eiceducation.com.cn";
      } else {
        url = "https://online-gre.eiceducation.com.cn";
      }
      break;
    case 4:
      if (getEnvironment() == "_test") {
        url = "https://online-sat-test.eiceducation.com.cn";
      } else {
        url = "https://online-sat.eiceducation.com.cn";
      }
      break;
    case 5:
      if (getEnvironment() == "_test") {
        url = "https://online-adaptive-test.eiceducation.com.cn";
      } else {
        url = "https://online-adaptive.eiceducation.com.cn";
      }
      break;
    case 1231:
      if (getEnvironment() == "_test") {
        url = "https://online-gre-test.eiceducation.com.cn";
      } else {
        url = "https://online-gre.eiceducation.com.cn";
      }
      break;
  }
  return url;
};
// const gatAllNavUrl = async (itemData, restart) => {
//   let baseUrl = "";
//   let url = "";
//   let adaptiveCallBackId = "";
//   if (
//     [237, 238, 239, 157, 158, 236, 156].indexOf(itemData.CourseType - 0) > -1
//   ) {
//     let res = await VM.$http.post(
//       "https://schoolapi.eiceducation.com.cn/api/AdaptiveTest",
//       {
//         CourseType: itemData.CourseType,
//         TestPaperId: itemData.TestPaperId,
//         Title: itemData.Title
//       },
//       {
//         headers: {
//           token: VM.$cookies.get("token")
//         }
//       }
//     );
//     if (res.data.code == 200) {
//       adaptiveCallBackId = res.data.results;
//     }
//   }

//   switch (itemData.CourseType - 0) {
//     case 3:
//     case 237:
//     case 238:
//     case 239:
//       if (getEnvironment() == "_test") {
//         baseUrl = "https://online-toefl-test.eiceducation.com.cn";
//       } else {
//         baseUrl = "https://online-toefl.eiceducation.com.cn";
//       }
//       if (itemData.CourseType == 3) {
//         url = `${baseUrl}/progress?testPaperId=${itemData.TestPaperId}&is_clear_storge=1`;
//       } else {
//         url = `${baseUrl}/progress?testPaperId=${itemData.TestPaperId}&is_adaptive=1&adaptiveCallBackId=${adaptiveCallBackId}&is_clear_storge=1`;
//       }
//       break;
//     case 2:
//     case 157:
//     case 158:
//     case 236:
//       if (getEnvironment() == "_test") {
//         baseUrl = "https://online-ielts-test.eiceducation.com.cn";
//       } else {
//         baseUrl = "https://online-ielts.eiceducation.com.cn";
//       }
//       if (itemData.CourseType == 2) {
//         url = `${baseUrl}/progress?sectionId=${itemData.TestPaperId}&pageMeta=1`;
//       } else {
//         url = `${baseUrl}/progress?sectionId=${itemData.TestPaperId}&pageMeta=1&is_adaptive=1&adaptiveCallBackId=${adaptiveCallBackId}`;
//       }
//       break;
//     case 4:
//       if (getEnvironment() == "_test") {
//         baseUrl = "https://online-gre-test.eiceducation.com.cn";
//       } else {
//         baseUrl = "https://online-gre.eiceducation.com.cn";
//       }
//       url = `${baseUrl}/progress?id=${itemData.TestPaperId}&type=test`;
//       break;
//     case 607:
//       if (getEnvironment() == "_test") {
//         baseUrl = "https://online-sat-test.eiceducation.com.cn";
//       } else {
//         baseUrl = "https://online-sat.eiceducation.com.cn";
//       }
//       url = `${baseUrl}?sectionId=${itemData.TestPaperId}&pageMeta=1`;
//       break;
//     case 156:
//       if (getEnvironment() == "_test") {
//         baseUrl = "https://online-adaptive-test.eiceducation.com.cn";
//       } else {
//         baseUrl = "https://online-adaptive.eiceducation.com.cn";
//       }
//       url = `${baseUrl}/progress?testPaperId=${itemData.TestPaperId}&is_adaptive=1&adaptiveCallBackId=${adaptiveCallBackId}`;
//       break;
//   }
//   let tempWindow = window.open("/loading", getRandom(999, 100));
//   let res = await setEncryption({
//     token: VM.$cookies.get("token")
//   });
//   console.log("url", url);
//   url = `${url}&restart=${restart}`;
//   if (res.data.code == 200) {
//     tempWindow.location.href = `${url}&ep=${
//       res.data.results
//     }&timestamp=${getRandom(999, 100)}`;
//   } else {
//     tempWindow.close();
//   }
// };
export const openInNewTab = (url) => {
  let tempWindow = window.open('', getRandom(999, 100));
  if (tempWindow) {
    setTimeout(() => {
      tempWindow.location.href = url;
    }, 500);
  } else {
    VM.$alert(
      "受浏览器策略影响，暂不能自动跳转到试卷答题，请点击下方“去答题”按钮去答题",
      {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: "去答题",
        callback: (action) => {
          if (action == "confirm") {
            let tempWindow = window.open("", getRandom(999, 100));
            tempWindow.location.href = url;
          }
        },
      }
    );
  }

};
/**
 * paperId  试卷id
 * a_type   1：试卷  2：section
 * a_flag    1：答题  2：查看结果页
 * contentType   回调type值
 * title  试卷名称
 * courseType   试卷类型
 * restart   断点续答
 *transcript 成绩单id
 adaptiveCallBackId 回调id
 isPractice 1:练习系统点进来的
 *  */
let btnDisabled = false;
export const gatAllNavUrl = async (itemData = {}) => {
  console.log("itemData", itemData);
  if (!Object.keys(itemData).length || !itemData.paperId) {
    Message.warning("缺少参数，禁止跳转，请稍后重试");
    return;
  }
  if (btnDisabled) return;
  btnDisabled = true;
  itemData.a_type = itemData.a_type ? itemData.a_type : 1;
  itemData.a_flag = itemData.a_flag ? itemData.a_flag : 1;
  let baseUrl = "";
  let {
    paperId = "",
    a_type = "",
    Title = "",
    CourseType = "",
    adaptiveCallBackId = "",
    systemId = 7
  } = itemData;
  if
    (a_type == 1 &&
    !adaptiveCallBackId &&
    !itemData.isPractice
  ) {
    let res = await addUserTask({
      ContentType: itemData.ContentType,
      CourseType,
      TestPaperId: paperId,
      Title
    });
    if (res.data.code == 200) {
      adaptiveCallBackId = res.data.results;
    } else {
      btnDisabled = false;
      return;
    }
  }
  console.log("CourseType", CourseType);
  if(paperId){
    let versionRes = await getPageVersion(paperId,a_type==2?23:21)
    console.log(versionRes,'versionRes')
    if(versionRes .data.result==1){
      gatNewNavUrl(itemData, adaptiveCallBackId)
      return
    }
  }
  
  if (getEnvironment() == "_test") {
    baseUrl = "https://online-adaptive-test.eiceducation.com.cn";
  } else {
    baseUrl = "https://online-adaptive.eiceducation.com.cn";
  }
  console.log("adaptiveCallBackId", adaptiveCallBackId);
  let res = await setEncryption({
    paperId: itemData.paperId,
    a_type: itemData.a_type,
    a_flag: itemData.a_flag,
    contentType: itemData.ContentType,
    courseType: itemData.CourseType,
    restart: itemData.restart,
    token: VM.$cookies.get("token"),
    systemId,
    adaptiveCallBackId,
    transcript: itemData.transcript,
  });
  if (res.data.code == 200) {
    let url = `${baseUrl}/mock/login/${res.data.results
      }?state=2&timestamp=${getRandom(999, 100)}`;
    openInNewTab(url);
  }
  btnDisabled = false;
};
const gatNewNavUrl = async (itemData, adaptiveCallBackId) => {
  let baseUrl = "";
  let {
    restart = '',
    a_type = "",
    systemId = 7,
    transcript = '',
    a_flag = 1
  } = itemData;
  console.log(itemData, 'itemData')
  if (getEnvironment() == "_test") {
    baseUrl = "https://testopia-test.eiceducation.com.cn/mock-exam";
  } else {
    baseUrl = "https://www.eictestopia.com/mock-exam";
  }
  console.log("adaptiveCallBackId", adaptiveCallBackId);
  if ([1, 2].indexOf(restart - 0) > -1) {
    transcript = ''
  } else if (restart == 3) {
    if (!transcript && (itemData.CourseType != 3 && itemData.CourseTypePid != 3)) {
      Message.warning("缺少参数，禁止跳转，请稍后重试");
      btnDisabled = false;
      return;
    }
  }
  setMockEncryption({
    token: VM.$cookies.get("token"),
    systemId,
    callBackId: adaptiveCallBackId,
  }).then(res => {
    console.log("res", res);
    if (res.data.succ) {
      let url = `${baseUrl}/?testPaperId=${itemData.paperId}&transcriptId=${transcript || ''}&is_adaptive=${itemData.IsAdaptive?1:0}&ep=${encodeURIComponent(res.data.result)}&timestamp=${getRandom(999, 100)}`;
      if (a_type == 2) {
        url = `${baseUrl}/section/?sectionId=${itemData.paperId}&answerSectionId=${transcript || ''}&ep=${encodeURIComponent(res.data.result)}&timestamp=${getRandom(999, 100)}`;
      }
      //查看结果页
      if (a_flag == 2) {
        url = `${baseUrl}/result/paper/${itemData.paperId}/${transcript || ''}?ep=${encodeURIComponent(res.data.result)}&timestamp=${getRandom(999, 100)}`;
        if (a_type == 2) {
          url = `${baseUrl}/result/part/${itemData.paperId}/${transcript || ''}?ep=${encodeURIComponent(res.data.result)}&timestamp=${getRandom(999, 100)}`;
        }
      }
      console.log("url", url);
      openInNewTab(url);
    }
  }).finally(() => {
    btnDisabled = false;
  })

}
/**
 * 判断当前设备是否为移动端
 * @returns {boolean} true-移动端, false-PC端
 */
export const isMobileDevice = () => {
  let isMobile = window.matchMedia("(pointer:coarse)").matches;
  return isMobile
}
export default {
  getEnvironment,
  getRandom,
  myFormater,
  getWindowNavUrl,
  gatAllNavUrl,
  isMobileDevice
};



// WEBPACK FOOTER //
// ./src/common/utils.js